import { customElement } from 'aurelia-framework';
import { NavModel } from 'aurelia-router';
import { bindable } from 'aurelia-typed-observable-plugin';

@customElement('bs-nav-item')
export class NavItem {
  @bindable item: NavModel;
  @bindable linkClicked: (args: LinkClickedArgs) => true;
}

export interface LinkClickedArgs { nav: NavModel }
